import { Text } from '@/components/atoms/text';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MessageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  gap: theme.spacing(1.5),
}));

export const Message = styled(Box)(({ theme }) => ({
  maxWidth: '100%',
  minWidth: '124px',
  padding: theme.spacing(1.5),
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));

export const AIIcon = styled(Box)(() => ({
  width: 32,
  height: 32,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const Timestamp = styled(Text)(({ theme }) => ({
  fontSize: '0.75rem',
  color: 'inherit',
  opacity: 0.7,
  marginTop: theme.spacing(1),
}));
